import React, { Fragment, useEffect, useState } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import {
  getCountInterventionsByExercice,
  getExerciceDetails,
  getListeEquipeMission,
  getListeReponseMission,
  VerrouQestion,
} from "../../../data/exercice";
import { optionsSwal, toAbsoluteUrl } from "../../../helpers/AssetsHelpers";
import {
  Button,
  Divider,
  notification,
  Popover,
  Space,
  Tag,
  Tooltip,
} from "antd";
import Swal from "sweetalert2";
import swal from "sweetalert";
import { useSelector } from "react-redux";
import { Identification } from "../../../components/client/modals/IdentificationMission";
import clsx from "clsx";
import { appTheme } from "../../../config/theme";
import { FormContainer } from "../../../components/common/common.components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelopeOpen,
  faFolderOpen,
  faLock,
  faUnlock,
  faBuilding,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import { faListSquares } from "@fortawesome/free-solid-svg-icons/faListSquares";
import { FicheClientMenu } from "./ClientExploitationFiche";
import { useTheme } from "styled-components";
import MissionSommaireClient from "../../../components/modals/clients/MissionSommaireClient";

const ClientExploitationMission = ({
  missionSelected,
  client,
  setCode,
  setModalId,
  next,
  prev,
  clientSommaire,
  setIsAcceptationValid,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);

  // States locaux
  const [mission, setMission] = useState(missionSelected);
  const [equipes, setEquipes] = useState([]);
  const [listQuestionAdd, setListQuestionAdd] = useState([]);
  const [userSommaire, setUserSommaire] = useState(null);
  const [interventions, setInterventions] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isToggleOpen, setIsToggleOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedModalId, setSelectedModalId] = useState(null);

  // Couleurs pour avatars dynamiques
  const colors = ["primary", "danger", "warning", "info", "success"];

  /** -----------------------------
   *  API : Récupération d'un exercice
   * ----------------------------- */
  const fetchOneExercice = async (mission_id) => {
    try {
      const res = await getExerciceDetails(mission_id);
      if (res) setMission(res);
    } catch (error) {
      notification.error({
        description:
          error || "Impossible de récupérer les détails de l'exercice",
      });
    }
  };

  /** -----------------------------
   *  API : Interventions d'un client sur un exercice
   * ----------------------------- */
  const fetchInterventionsExerciceClient = async (client, mission) => {
    try {
      const res = await getCountInterventionsByExercice(client.id, mission.id);
      setInterventions(res);
    } catch (error) {
      console.error("Erreur interventions :", error);
    }
  };

  /** -----------------------------
   *  API : Équipes de la mission
   * ----------------------------- */
  const fetchEquipes = async (mission_id, user_id) => {
    try {
      const res = await getListeEquipeMission(mission_id);
      if (res) {
        setEquipes(res);
        const userTeam = res.find((item) => item.membre_id === user_id);
        if (userTeam) setUserSommaire(userTeam);
      }
    } catch (error) {
      console.error("Erreur équipes :", error);
    }
  };

  /** -----------------------------
   *  API : Liste des questions répondues
   * ----------------------------- */
  const fetchListeQuestionRepondu = async (mission_id) => {
    try {
      const res = await getListeReponseMission(mission_id);
      setListQuestionAdd(res);
    } catch (error) {
      console.error("Erreur questions :", error);
    }
  };

  /** -----------------------------
   *  Verrouiller / Déverrouiller un questionnaire
   * ----------------------------- */
  const handleVerrouQuestion = async (exercice_id, verou_question) => {
    Swal.fire(optionsSwal).then(async (result) => {
      if (!result.isConfirmed) return;

      setLoading(true);
      const data = { client_id: client.id, verou_question, exercice_id };

      const { status, message } = await VerrouQestion(data);

      if (status === "success") {
        await swal("Opération effectuée avec succès", "", "success");
        fetchOneExercice(exercice_id);
      } else {
        await swal(message, "", "error");
      }

      setLoading(false);
    });
  };

  /** -----------------------------
   *  Gestion des onglets
   * ----------------------------- */
  const handleTabChange = (tabIndex, e) => {
    e.preventDefault();
    setActiveTab(tabIndex);
  };

  /** -----------------------------
   *  Ouverture de modal
   * ----------------------------- */
  const handleOpenModal = (modal_id) => {
    setSelectedModalId(modal_id);
    setIsModalOpen((prev) => !prev);
  };

  /** -----------------------------
   *  Toggle du menu
   * ----------------------------- */
  const toggleMenu = (e) => {
    e.preventDefault();
    setIsToggleOpen(!isToggleOpen);
  };

  /** -----------------------------
   *  useEffect : Chargement mission
   * ----------------------------- */
  useEffect(() => {
    if (missionSelected) {
      fetchOneExercice(missionSelected.id);
      fetchInterventionsExerciceClient(client, missionSelected);
    }
  }, [missionSelected]);

  /** -----------------------------
   *  useEffect : Chargement équipes
   * ----------------------------- */
  useEffect(() => {
    if (mission && user) {
      fetchEquipes(mission.id, user.id);
    }
  }, [user, mission]);

  /** -----------------------------
   *  useEffect : Chargement questions
   * ----------------------------- */
  useEffect(() => {
    if (mission) {
      fetchListeQuestionRepondu(mission.id);
    }
  }, [mission]);

  /** -----------------------------
   *  Tabs (contenu de chaque étape)
   * ----------------------------- */
  const steps = [
    {
      id: 1,
      title: "Sommaire",
      description: "Sommaire de traitement de cycles LEA",
      content: (
        <MissionSommaireClient
          client={client}
          mission={mission}
          listQuestionAdd={listQuestionAdd}
          userSommaire={userSommaire}
          setModalId={setModalId}
          setCode={setCode}
          next={next}
          prev={prev}
          clientSommaire={clientSommaire}
          setIsMaintien={setIsAcceptationValid}
        />
      ),
    },
    {
      id: 2,
      title: "Historique",
      description: "Historique des interventions",
      content: <Identification mission={mission} client={client} />,
    },
  ];

  return (
    <>
      <Fragment>
        <FicheClientMenu>
          <div className="card mb-5 mb-xl-10">
            <div className="card-body pt-9 pb-0">
              <div className="d-flex flex-wrap flex-sm-nowrap">
                {/* Logo ou Initiales Client */}
                <div className="me-7 mb-4">
                  <div className="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative">
                    {client.logo_client ? (
                      <div className="symbol-label">
                        <img
                          src={toAbsoluteUrl(`/media/${client.logo_client}`)}
                          alt={client.denomination}
                          className="w-100"
                        />
                      </div>
                    ) : (
                      <div
                        className={clsx("symbol-label", `bg-green`)}
                        style={{
                          backgroundColor: appTheme.colors.bgColor,
                          fontSize: "40px",
                        }}
                      >
                        {client.denomination[0].toUpperCase() +
                          client.denomination[1].toUpperCase()}
                      </div>
                    )}
                    <div className="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px"></div>
                  </div>
                </div>

                {/* Informations Mission */}
                <div className="flex-grow-1">
                  <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                    {/* Titre mission */}
                    <div className="d-flex flex-column mb-2">
                      <div className="d-flex align-items-center mb-2">
                        <span
                          className="fw-bolder text-uppercase"
                          style={{
                            color: "royalblue",
                            fontSize: "36px",
                            fontWeight: "700",
                          }}
                        >
                          {mission.mission}
                        </span>

                        {/* Statut mission */}
                        <div className="ms-3">
                          {mission.isCloture ? (
                            <Tag color="green">Clôturé</Tag>
                          ) : mission.lettre_mission === 0 ? (
                            <Tag color="yellow">En attente</Tag>
                          ) : (
                            <Tag color="blue">En cours</Tag>
                          )}

                          {mission.isCloture && (
                            <>
                              <Tooltip title="Mission verrouillée" color="red">
                                <Tag
                                  color="red"
                                  icon={<FontAwesomeIcon icon={faLock} />}
                                />
                              </Tooltip>
                              <Popover
                                placement="top"
                                title="Motif de clôture"
                                content={
                                  <>
                                    <Divider />
                                    <span style={{ fontSize: "13px" }}>
                                      {mission.commentCloture}
                                    </span>
                                  </>
                                }
                              >
                                <Button
                                  icon={
                                    <FontAwesomeIcon
                                      icon={faExclamationCircle}
                                    />
                                  }
                                />
                              </Popover>
                            </>
                          )}
                        </div>
                      </div>

                      {/* Année et Client */}
                      <div className="d-flex align-items-center">
                        {mission.annee && (
                          <Tag
                            style={{ fontSize: "18px" }}
                            color={appTheme.colors.primary}
                          >
                            {mission.annee}
                          </Tag>
                        )}
                        <Tag
                          icon={
                            <FontAwesomeIcon
                              style={{ fontSize: "18px", marginRight: "5px" }}
                              icon={faBuilding}
                              color={appTheme.colors.primary_blue}
                            />
                          }
                        >
                          <span className="fw-bolder text-uppercase">
                            {client.sigle}
                          </span>
                        </Tag>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="d-flex">
                      <Space>
                        {mission?.fichier_question === 1 &&
                          mission?.etat === 2 && (
                            <Tooltip title="Lettre de mission">
                              <Button
                                shape="circle"
                                icon={
                                  <FontAwesomeIcon
                                    icon={faEnvelopeOpen}
                                    color="blue"
                                  />
                                }
                              />
                            </Tooltip>
                          )}
                        <Tooltip title="Document de la mission" color="yellow">
                          <Button
                            shape="circle"
                            icon={
                              <FontAwesomeIcon
                                icon={faFolderOpen}
                                color="yellow"
                              />
                            }
                            onClick={() => handleOpenModal(1)}
                          />
                        </Tooltip>
                        {mission.fichier_question === 1 &&
                          mission.lettre_mission === 0 &&
                          mission.isChefMission &&
                          mission.isManagerMission && (
                            <Tooltip
                              title={
                                mission?.verou_question === 0
                                  ? "Questionnaire déverrouillé"
                                  : "Questionnaire verrouillé"
                              }
                            >
                              <Button
                                shape="circle"
                                style={{
                                  backgroundColor:
                                    mission?.verou_question === 0
                                      ? "yellow"
                                      : "yellowgreen",
                                }}
                                icon={
                                  <FontAwesomeIcon
                                    icon={
                                      mission?.verou_question === 0
                                        ? faUnlock
                                        : faLock
                                    }
                                    color="white"
                                  />
                                }
                                onClick={() =>
                                  handleVerrouQuestion(
                                    mission.id,
                                    mission?.verou_question === 1 ? 0 : 1
                                  )
                                }
                              />
                            </Tooltip>
                          )}
                      </Space>

                      {/* Bouton retour + menu */}
                      <div className="d-flex ms-5">
                        <Link
                          to={`/clients/exploitation/fiche/${client?.id}`}
                          state={{ record: client }}
                          className="btn btn-sm btn-light-danger me-3"
                        >
                          Retour
                        </Link>
                        <Tooltip title="Voir plus">
                          <div>
                            <button
                              className="btn btn-sm btn-flex btn-primary"
                              onClick={toggleMenu}
                            >
                              <EllipsisOutlined />
                            </button>
                            {isToggleOpen && (
                              <div className="menu menu-sub show w-200px py-4">
                                <div className="menu-item px-3">Test</div>
                                <div className="menu-item px-3">Test 2</div>
                              </div>
                            )}
                          </div>
                        </Tooltip>
                      </div>
                    </div>
                  </div>

                  {/* Interventions + Equipes */}
                  <div className="d-flex flex-wrap flex-stack">
                    <div className="d-flex flex-column flex-grow-1 pe-8">
                      <div className="d-flex flex-wrap">
                        <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                          <div className="d-flex align-items-center">
                            <Tag
                              icon={<FontAwesomeIcon icon={faListSquares} />}
                              color={theme.colors.primary_blue}
                            />
                            <div className="fs-2 fw-bold">{interventions}</div>
                          </div>
                          <div className="fw-semibold fs-6 text-gray-500">
                            Interventions
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Liste des membres */}
                    <div className="symbol-group symbol-hover mb-3">
                      {equipes.map((item, index) => (
                        <div
                          key={index}
                          className="symbol symbol-35px symbol-circle"
                        >
                          {item.avatar ? (
                            <img
                              src={toAbsoluteUrl(`/media/${item.avatar}`)}
                              alt={item.Lea_User?.nom_user}
                              className="w-100"
                            />
                          ) : (
                            <Tooltip
                              title={`${item.Lea_User?.nom_user} ${item.Lea_User?.prenom_user}`}
                            >
                              <span
                                className={`symbol-label bg-${
                                  colors[
                                    Math.floor(Math.random() * colors.length)
                                  ]
                                } text-white fw-bolder`}
                              >
                                {item.Lea_User?.nom_user[0].toUpperCase()}
                              </span>
                            </Tooltip>
                          )}
                        </div>
                      ))}

                      {/* Bouton "voir plus" */}
                      <button
                        onClick={() => handleOpenModal(2)}
                        className="symbol symbol-35px symbol-circle"
                      >
                        <span className="symbol-label bg-dark text-white">
                          ...
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              {/* Onglets navigation */}
              <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
                {steps.map((step, index) => (
                  <li key={index} className="nav-item">
                    <Tooltip title={step.description}>
                      <button
                        data-bs-toggle="tab"
                        className={`nav-link fs-4 btn btn-active-light btn-color-gray-600 btn-active-color-primary rounded-bottom-0 ${
                          activeTab === index ? "active" : ""
                        }`}
                        onClick={(e) => handleTabChange(index, e)}
                      >
                        {step.title}
                      </button>
                    </Tooltip>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </FicheClientMenu>

        {/* Contenu des onglets */}
        <FormContainer>
          <div className="tab-content" id="myTabContent">
            {steps.map((item, index) => (
              <div
                key={index}
                className={`tab-pane fade ${
                  activeTab === index ? "show active" : ""
                }`}
                id={`tab-${index}`}
                role="tabpanel"
              >
                {steps[activeTab].content}
              </div>
            ))}
          </div>
        </FormContainer>
      </Fragment>
    </>
  );
};

export { ClientExploitationMission };
